import {
  ISlideData,
  ISlideDataModel,
  IDrawingShapeData,
  DataType,
  IShapeData,
  IDrawingShapeDataModel,
} from '@tencent/slide-sdk-model';

export const traverseShapeList = <T extends IDrawingShapeDataModel | IDrawingShapeData>(
  shapeList: T[],
  action: (shape: T) => void,
): void => {
  for (const shape of shapeList) {
    action(shape);

    if (shape.type === DataType.GroupShape) {
      traverseShapeList(shape.shapeList as T[], action);
    }
  }
};

export const getShapesInShapeList = <T extends IDrawingShapeDataModel | IDrawingShapeData>(
  shapeList: T[],
  predict: (shape: T) => boolean,
): T[] => {
  const shapes: T[] = [];

  traverseShapeList(shapeList, (shape) => {
    if (predict(shape)) shapes.push(shape);
  });

  return shapes;
};

export const getShapeInShapeList = (
  shapeList: IDrawingShapeData[],
  predict: (shape: IDrawingShapeData) => boolean,
): IDrawingShapeData | null => {
  for (const shape of shapeList) {
    if (predict(shape)) return shape;

    if (shape.type === DataType.GroupShape) {
      const res = getShapeInShapeList(shape.shapeList, predict);
      if (res) return res;
    }
  }
  return null;
};

export const getShapeInSlide = (
  slideData: ISlideData,
  predict: (shape: IDrawingShapeData) => boolean,
): IDrawingShapeData | null => {
  if (!slideData.cSld.spTree) return null;

  return getShapeInShapeList(slideData.cSld.spTree.shapeList, predict);
};

export const getShapeByIdInSlide = (slideData: ISlideData, shapeId: string): IDrawingShapeData | null => {
  return getShapeInSlide(slideData, (shape) => shape.id === shapeId);
};

export const deleteShapeByIdInSlide = (slideData: ISlideData, shapeId: string): void => {
  if (!slideData.cSld.spTree) return;

  deleteShapeInShapeList(slideData.cSld.spTree.shapeList, shapeId);
};

export const deleteShapeInShapeList = (shapeList: IDrawingShapeData[], shapeId: string): boolean => {
  for (let index = 0; index < shapeList.length; index++) {
    const shape = shapeList[index];

    if (shape.id === shapeId) {
      shapeList.splice(index, 1);
      return true;
    }

    if (shape.type === DataType.GroupShape) {
      const res = deleteShapeInShapeList(shape.shapeList, shapeId);
      if (res) return true;
    }
  }

  return false;
};

export const getShapeTextRun = (shapeModel: IShapeData) => {
  if (!shapeModel.txBody?.p) return '';
  let content = '';

  shapeModel.txBody.p.forEach((para) => {
    if (para.egTextRun && para.egTextRun.length > 0) {
      content = `${content} ${para.egTextRun.reduce((res, curText) => res + curText.r?.t, '')}`;
    }
  });
  return content.trim();
};

// const getText = (p) => {
//     return p.map(para => {
//         const { buChar, buAutoNum, lvl = 0 } = para.pPr;
//         if (buChar || buAutoNum) {
//             return `${Array(lvl).fill('\t').join('  ')}- ${para.egTextRun[0].r.t}`
//         }

//         return para.egTextRun[0].r.t;
//     }).join('\n');
// }
